import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchModal'
})
export class SearchModalPipe implements PipeTransform {

  transform<T>(lista: T[] | null, textoABuscar: string, campos: string[] = []): T[] | null {
    if (!lista || !textoABuscar) {
      return lista;
    }

    const criteriosBusqueda = textoABuscar.split(',').map(criterio => criterio.trim().toLowerCase());

    return lista.filter((item: T) =>
      campos.some((campo: string) => {
        const valorCampo = (item as any)[campo];
        if (valorCampo !== undefined && valorCampo !== null) {
          return criteriosBusqueda.some(criterio => valorCampo.toString().toLowerCase().includes(criterio));
        }
        return false;
      })
    );
  }
}
